import OrderSummary from 'Components/Elements/OrderSummaryElement/OrderSummary'
import useOrderSummary from 'Stores/OrderSummary/useOrderSummary'

export default function OrderSummaryPage() {
  useOrderSummary()
  return (
    <OrderSummary />
  )
}
